import { SERVICE_CATALOG_HEALTH_STATUSES } from 'domain/shared/serviceCatalog';

export const SERVICE_HEALTH_ISSUES = {
  NO_SERVICE_OWNER: 'NO_SERVICE_OWNER',
  NO_BUDGET_STRUCTURE: 'NO_BUDGET_STRUCTURE',
  NO_KPI_STRUCTURE: 'NO_KPI_STRUCTURE',
  WAITING_FOR_KPI_VALUES: 'WAITING_FOR_KPI_VALUES',
  MISSING_KPI_VALUES: 'MISSING_KPI_VALUES',
};

export const SERVICE_HEALTH_ISSUES_OPTIONS = {
  [SERVICE_HEALTH_ISSUES.NO_SERVICE_OWNER]: 'No service owner',
  [SERVICE_HEALTH_ISSUES.NO_BUDGET_STRUCTURE]: 'No costs structure',
  [SERVICE_HEALTH_ISSUES.NO_KPI_STRUCTURE]: 'No KPI structure',
  [SERVICE_HEALTH_ISSUES.WAITING_FOR_KPI_VALUES]: 'Waiting for KPI values',
  [SERVICE_HEALTH_ISSUES.MISSING_KPI_VALUES]: 'Missing KPI values',
};

export const SERVICE_HEALTH_ISSUES_IMPORTANCE = {
  [SERVICE_HEALTH_ISSUES.NO_SERVICE_OWNER]: SERVICE_CATALOG_HEALTH_STATUSES.CRITICAL,
  [SERVICE_HEALTH_ISSUES.NO_BUDGET_STRUCTURE]: SERVICE_CATALOG_HEALTH_STATUSES.CRITICAL,
  [SERVICE_HEALTH_ISSUES.NO_KPI_STRUCTURE]: SERVICE_CATALOG_HEALTH_STATUSES.CRITICAL,
  [SERVICE_HEALTH_ISSUES.WAITING_FOR_KPI_VALUES]: SERVICE_CATALOG_HEALTH_STATUSES.WARNING,
  [SERVICE_HEALTH_ISSUES.MISSING_KPI_VALUES]: SERVICE_CATALOG_HEALTH_STATUSES.CRITICAL,
};

export const SERVICE_HEALTH_ISSUES_DESCRIPTION = {
  [SERVICE_HEALTH_ISSUES.NO_SERVICE_OWNER]: 'Assign an owner to this service.',
  [SERVICE_HEALTH_ISSUES.NO_BUDGET_STRUCTURE]: 'Define costs structure in order to allow budget proposals.',
  [SERVICE_HEALTH_ISSUES.NO_KPI_STRUCTURE]: 'Define KPI structure.',
  [SERVICE_HEALTH_ISSUES.WAITING_FOR_KPI_VALUES]:
    'Fill in KPI values for previous accounting cycle within 5 days after the end of the cycle.',
  [SERVICE_HEALTH_ISSUES.MISSING_KPI_VALUES]: 'Fill in KPI values for previous accounting cycle as soon as possible.',
};
